import styled, { css } from 'styled-components';

export const HiddenMountContainer = styled.div<{ $hidden: boolean }>`
  ${({ $hidden }) =>
    $hidden &&
    css`
      display: none;
    `}
`;
